export type HexColor = `#${string}`;

type Separator = ',' | ', ';

export type RgbColor = `rgb(${number}${Separator}${number}${Separator}${number})`;

export type RgbaColor =
  | `rgba(${number}${Separator}${number}${Separator}${number}${Separator}${number})`
  | `rgba(${number}${Separator}${number}${Separator}${number})`;

export const ColorVariant = Object.freeze({
  Chip: 'chip',
  Error: 'error',
  Info: 'info',
  Pending: 'pending',
  Success: 'success',
  Warning: 'warning',
} as const);

/**
 * Defines a color scheme that is associated with a certain color palette defining colors for
 * multiple CSS properties, like background color, border color, text color, and icon color.
 *
 * This variant can be used by components in @craft/ui to apply consistent color schemes on
 * elements when those schemes affect multiple CSS properties of the element.
 */
export type ColorVariant = (typeof ColorVariant)[keyof typeof ColorVariant];

export const ColorCode = Object.freeze({
  Hex: 'hex',
  Rgb: 'rgb',
  Rgba: 'rgba',
} as const);

export type ColorCode = (typeof ColorCode)[keyof typeof ColorCode];

export type ColorString<F extends ColorCode = ColorCode> = {
  [ColorCode.Hex]: HexColor;
  [ColorCode.Rgb]: RgbColor;
  [ColorCode.Rgba]: RgbaColor;
}[F];
